import React from 'react';
import ReactDOM from 'react-dom/client';
import { AppContextProvider } from '@/context/AppContextProvider';
import { ToastProvider } from '@/components/ui/Toast';
import { MotionProvider } from '@/components/ui/motion';
import { ErrorBoundary } from '@/components/error';
import { App } from '@/App';
import '@/config/i18n';
/** Tailwind utility classes �?" layer-based, additive to existing CSS */
import '@/styles/tailwind.css';
/** CampusOne design tokens + global styles �?" these override Tailwind's utility layer */
import '@/styles/variables.css';
import '@/styles/global.css';
import '@/styles/layout.css';
import '@/styles/components.css';
/** CampusOne C1 primitives — login-theme parity; prefer @/components/c1 over raw CSS */
import '@/styles/c1.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <MotionProvider>
      <ErrorBoundary>
        <AppContextProvider>
          <ToastProvider>
            <App />
          </ToastProvider>
        </AppContextProvider>
      </ErrorBoundary>
    </MotionProvider>
  </React.StrictMode>,
);
